export default __webpack_public_path__ + "static/media/SEC1910.34I-40942_-24262_0.871eca5e.jpg";